/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMarketingConsentDto } from '../../models/create-marketing-consent-dto';
import { MarketingConsentDto } from '../../models/marketing-consent-dto';

export interface MarketingConsentControllerCreateV1$Params {
      body: CreateMarketingConsentDto
}

export function marketingConsentControllerCreateV1(http: HttpClient, rootUrl: string, params: MarketingConsentControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingConsentDto>> {
  const rb = new RequestBuilder(rootUrl, marketingConsentControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarketingConsentDto>;
    })
  );
}

marketingConsentControllerCreateV1.PATH = '/api/v1/marketing-consent';
